import { render, staticRenderFns } from "./VSelectInput.vue?vue&type=template&id=72638701"
import script from "./VSelectInput.vue?vue&type=script&lang=ts"
export * from "./VSelectInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports